<template>
    <b-modal
        id="faq-add-category-modal"
        ref="faq-add-category-modal"
        size="md"
        :title="$t('admin.add_category')"
        modal-class="apprentice-default-modal add-afaq-category"
        :ok-title="$t('common.save')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @show="show"
        @ok="onOk">
        <div class="add-faq-category">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    v-for="(error, index) in errors"
                    v-if="error.error"
                    :key="index"
                    show
                    variant="danger">
                    {{ error.message }}
                </b-alert>
            </div>

            <b-alert
                show
                variant="warning">
                {{ $t('admin.all_fields_are_required') }}
            </b-alert>

            <b-form-group
                class="faq-category-name"
                label-for="faq-category-name-input"
                label="Naam">
                <b-form-input
                    id="faq-category-name-input"
                    v-model="name"
                    :placeholder="$t('admin.category_name')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="faq-category-visibility"
                v-slot="{ ariaDescribedby }"
                :label="$t('admin.visible_for')">
                <b-form-checkbox-group
                    class="apprentice-checkbox-group"
                    id="faq-category-visibility"
                    v-model="visibility"
                    :options="options"
                    :aria-describedby="ariaDescribedby"
                    name="visibility">
                </b-form-checkbox-group>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../../app';

export default {
    name: 'design-2021-add-category-modal-component',
    props: ['orderIn'],
    data() {
        return {
            name: '',
            visibility: [],
            options: [
                { text: this.$t('admin.students'), value: 'student' },
                { text: this.$t('admin.teachers'), value: 'teacher' },
            ],
            hasError: false,
            errors: {
                name: {
                    error: false,
                    message: this.$t('admin.name_field_cannot_be_empty'),
                },
            },
        };
    },

    methods: {
        show() {
            this.visibility = [];
            this.name = '';
            this.clearError();
        },

        onOk(vbModalEvent) {
            if (this.foundError()) {
                vbModalEvent.preventDefault();
                return;
            }

            let data = {
                name: this.name,
                visibility: this.visibility,
                order: this.orderIn,
            };

            this.alert.saving();
            this.axios.post(this.routes.adminAfaqCategory(), data).then(
                (response) => {
                    ords.use('AfaqCategory').add(response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        foundError() {
            this.clearError();

            if (this.name === '') {
                this.hasError = true;
                this.errors.name.error = true;
            }
            return this.hasError;
        },

        clearError() {
            this.hasError = false;
            this.errors.name.error = false;
        },
    },
};
</script>

<style scoped></style>
